module.exports = __webpack_public_path__ + "img/avatar5.635026ba.png";